import { Component, OnInit } from '@angular/core';
import { EmployeeService } from '../../../../../shared/_services/employee.service';
import { Subject } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { AddCommentComponent } from '../../../../modals/add-comment/add-comment.component';
import { StatusModalComponent } from '../../../../modals/status-modal/status-modal.component';

@Component({
  selector: 'app-employee-comments',
  templateUrl: './employee-comments.component.html',
  styleUrls: ['./employee-comments.component.scss']
})
export class EmployeeCommentsComponent implements OnInit {
  p: number = 0;
  size: number = 10;
  totalCount: number = 0;
  employeeId: any;
  commentsList: any[] = [];
  tableHeader: any = [
    { 'key': 'Created on', 'property': 'createdDate', 'direction': 'asc' },
    { 'key': 'Comment', 'property': 'comments', 'direction': null },
    { 'key': 'User', 'property': 'memberId', 'direction': null },
  ];
  statusModal: BsModalRef;
  private unsubscribe: Subject<void> = new Subject<void>();
  constructor(
    private modalService: BsModalService,
    private employeeService: EmployeeService
  ) { 
    this.modalService.onHide
    .takeUntil(this.unsubscribe)
    .subscribe(res => {
      if (this.statusModal) {
        if (this.statusModal.content.srcObject.action == "action1") {
          if (this.statusModal.content.srcObject.type == "member-edit") {
            if (this.statusModal.content.srcObject.status || this.statusModal.content.srcObject.status == 0) {
              let status = +this.statusModal.content.srcObject.status;
              this.activateOrDeactivate(this.statusModal.content.srcObject.id, status);
            } else {
              this.getCommentsList(this.employeeId);
            }
          } else {
            this.getCommentsList(this.employeeId);
          }
        }
      }
    })
  }

  activateOrDeactivate(commentId, statusId) {
    console.log(`change status for ${commentId} to ${statusId == 0 ? 'Deactivate' : 'Activate'}`);
    this.employeeService.activateOrDeactivateEmployeeComment(commentId, statusId).subscribe(res => {
      this.pageChanged(1);
    }, err => {
      console.error('Error while updating promotion status: ', err.message);
    });
  }


  sortTable(property: any) {
    this.tableHeader.forEach((header: any) => {
      if (header.property === property) {
        header.direction = header.direction && header.direction == 'asc' ? 'desc' : 'asc';
        // header.direction = !header.direction;
      }
      if (header.property !== property) {
        header.direction = null;
      }
    });
    this.pageChanged(1);
  }

  pageChanged($event) {
    let page = $event - 1;
    this.getCommentsList(this.employeeId, page);
    this.p = $event;
  }

  getCommentsList(empId?, page?) {
    let data = {
      page: page != null ? page : this.p,
      sorting: this.tableHeader
    }
    this.employeeService.getEmployeeCommentsByMemberId(empId, data).subscribe(res => {
      if (res.error == 0) {
        // this.commentsList = res.responseObj;
        this.commentsList = res.responseObj.results;
        this.totalCount = res.responseObj.totalRecords;
      }
    }, err => {
      console.error('Error while getting list of comments with member id: ', err.message);
    })
  }

  openStatusModal(id?, status?) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: "custom",
      type: 'member-edit',
      title: "Delete Comment",
      message: "Are you sure you want to delete this comment?",
      status,
      id,
      action1: "Delete",
      action2: "Cancel",
      action: '',
      style: "inactive",
    }
  }

  openModalAddComment() {
    this.statusModal = this.modalService.show(AddCommentComponent, { class: 'add-comment-modal' });
    if (this.employeeId) {
      this.statusModal.content.employeeId = this.employeeId;
    }
  }

  ngOnInit() {
    this.employeeId = this.employeeService.employeeId;
    this.getCommentsList(this.employeeId);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/employees/employee-comments/employee-comments.component.ts